import React from "react";
import { fetch as router } from "helpers/router";

const ProfileAnchor = ({ profile }) => {
  if (!profile) {
    return null;
  }

  const profileImage = profile.image ?? "/images/avatar-default.svg";
  const fullName = `${profile.first_name} ${profile.last_name}`;

  return (
    <a
      className="avatar --size-xsmall"
      href={router("web.dashboard")}
      title={fullName}
      style={{ backgroundImage: `url(${encodeURI(profileImage)})` }}
    >
      <img className="avatar__image" src={profileImage} alt={profile.first_name} />
    </a>
  );
};

export default ProfileAnchor;
